import { useId, type ReactNode } from 'react';
import {
  RecordingAlertBanner,
  RecordingAlertBox,
  RecordingAlertText,
  RecordingAlertTitle,
  type RecordingAlertVariant,
} from 'widgets/recording/RecordingBottomNavbar.styles';

interface RecordingAlertProps {
  icon: ReactNode;
  title: string;
  text: string;
  role?: 'alert' | 'status';
  variant?: RecordingAlertVariant;
  quietText?: boolean;
  actions?: ReactNode;
  /** Keeps device names out of the session recording. */
  maskText?: boolean;
}

export const RecordingAlert = ({
  icon,
  title,
  text,
  role = 'alert',
  variant = 'error',
  quietText = false,
  actions,
  maskText = false,
}: RecordingAlertProps) => {
  const titleId = useId();

  return (
    <RecordingAlertBox role={role} $variant={variant} aria-labelledby={titleId}>
      <RecordingAlertText>
        {icon}
        <div className="min-w-0">
          <RecordingAlertTitle id={titleId} $masked={maskText}>
            {title}
          </RecordingAlertTitle>
          <RecordingAlertBanner aria-hidden={quietText || undefined} $masked={maskText}>
            {text}
          </RecordingAlertBanner>
        </div>
      </RecordingAlertText>
      {actions}
    </RecordingAlertBox>
  );
};
